
@if (isNew == true) {
  <h2 mat-dialog-title>Add Mentor Assignment</h2>
}
@if (isNew == false) {
  <h2 mat-dialog-title>End Mentor Assignment</h2>
}

<form [formGroup]="mentorAssignmentForm" class="form">
  <mat-dialog-content class="dialog-content">
    <div fxLayout="column" fxLayoutAlign="space-around start" fxFill>
      <mat-form-field class="hidden">
        <mat-label>ID</mat-label>
        <input matInput formControlName="assignmentID">
      </mat-form-field>

      <mat-form-field appearance="fill" [ngClass]="{'hidden' : isNew == true }">
        <mat-label>Mentor</mat-label>
        <input matInput formControlName="assignmentMentorName" readonly>
      </mat-form-field>

      <mat-form-field appearance="fill" [ngClass]="{'hidden' : isNew == false }">
        <mat-label>Mentor</mat-label>
        <mat-select formControlName="assignedMentorID" required>
          @for (mentor of mentorList; track mentor) {
            <mat-option [value]="mentor.MentorId">{{mentor.FirstName}} {{mentor.LastName}}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" [ngClass]="{'hidden' : isNew == true }">
        <mat-label>End Date</mat-label>
        <input [max]="today" matInput [matDatepicker]="assignmentEndDatePicker" placeholder="End Date" formControlName="assignmentEndDate">
        <mat-datepicker-toggle matSuffix [for]="assignmentEndDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #assignmentEndDatePicker></mat-datepicker>
        @if (hasError('assignmentEndDatePicker','matDatepickerMax')) {
          <mat-error>
            Date cannot be in the future
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="fill" [ngClass]="{'hidden' : isNew == false }">
        <mat-label>Start Date</mat-label>
        <input matInput [max]="today" [matDatepicker]="assignmentStartDatePicker" placeholder="Start Date" formControlName="assignmentStartDate">
        <mat-datepicker-toggle matSuffix [for]="assignmentStartDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #assignmentStartDatePicker></mat-datepicker>
        @if (hasError('assignmentStartDate','matDatepickerMax')) {
          <mat-error>
            Date cannot be in the future
          </mat-error>
        }
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button id="saveButton" type="submit" [disabled]="showSpinner" mat-button color="primary" mat-raised-button (click)="saveEdit()">Save</button>
    <button mat-button mat-dialog-close color="warn" mat-raised-button (click)="cancelEdit()">Cancel</button>
    @if (showSpinner) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </mat-dialog-actions>
</form>
